export { Component } from './sandbox.component'
